module.exports = __webpack_public_path__ + "img/phone_icon.bf40ad8b.svg";